<!-- <div *ngIf="loadingCalibrationHistory == true" class="col-xs-4 col-lg-3" style="margin-bottom: 20px;">
    <i class="fa fa-spinner fa-spin fa-1x fa-fw" style="margin: 30px 10px 0px 30px"></i>
    <span>Loading calibration history</span>
</div> -->

<div style="margin-top: 1px; width: 100%;">

    <p-table #sensorDataTable [columns]="calibrationHistoryCols" [value]="sensor.sensorCalibrationHistory" [scrollable]="true" scrollHeight="553px">
        <ng-template let-columns pTemplate="header">
            <tr style="height: 40px; margin-top: 1px;">
                <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" style="background-color: var(--kig-section-header-bg); flex: none;">
                    {{col.header}}
                </th>
            </tr>
        </ng-template>

        <ng-template let-rowData let-columns="columns" pTemplate="body">
            <tr *ngIf="rowData.equationId > -1" style="height: 35px;">
                <td [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px;">
                    <div class="css-tooltip" [attr.tooltip-data]="getSensorCalibrationTooltipForSensor(rowData)" style=" white-space: pre-wrap;">
                        <label style="margin-bottom: 3px; color: #5279bc">{{ rowData.sensorName == undefined ? sensor.uuid : rowData?.sensorName | slice:0:17 }}<span *ngIf="rowData?.sensorName?.length > 17">...</span> </label>
                    </div>
                    <div>
                        <label>{{ rowData?.sensorReadingTypeName | slice:0:17 }}<span *ngIf="rowData?.sensorReadingTypeName?.length > 17">...</span> </label>
                    </div>
                </td>

                <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px;">
                    {{ rowData?.templateName }}
                </td>

                <td [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px; white-space: pre-wrap;">
                    {{ rowData?.parametersDisplay }}
                </td>

                <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px;">
                    <!-- <ng-container *ngIf="editingRow !== rowData; else editDatesTemplate">
                        <div class="date-range-cell">
                            <div>{{ rowData?.startDate | date : 'medium' }}</div>
                            <div style="color: #888;">{{ rowData?.modifiedDate | date : 'medium' }}</div>
                        </div>
                    </ng-container>
                    <ng-template #editDatesTemplate>
                        <div class="date-range-cell">
                            <input type="datetime-local" [(ngModel)]="editingStartDate" class="edit-date-input" />
                        </div>
                    </ng-template> -->
                    <ng-container>
                        <div class="date-range-cell">
                            <div>{{ rowData?.startDate | date : 'medium' }}</div>
                            <div style="color: #888;">{{ rowData?.modifiedDate | date : 'medium' }}</div>
                        </div>
                    </ng-container>
                </td>

                <td [ngStyle]="{'width': columns[4].width}" style="flex: none; border-width: 0px;">
                    {{ rowData?.modifiedByUserName | slice:0:17 }}<span *ngIf="rowData?.modifiedByUserName?.length > 17">...</span>
                </td>

                <td [ngStyle]="{'width': columns[5].width}" style="flex: none; border-width: 0px;">
                    <ng-container *ngIf="editingRow !== rowData; else editNotesTemplate">
                        <div aria-hidden="true" class="css-tooltip3" [attr.tooltip-data]="rowData?.notesObj?.userNotes">
                            <i class="fa-regular fa-comment" style="color:#5279bc; font-size: 14px;"></i>
                        </div>
                    </ng-container>
                    <ng-template #editNotesTemplate>
                        <input type="text" [(ngModel)]="editingUserNotes" class="edit-notes-input" placeholder="Enter notes..." />
                    </ng-template>
                </td>

                <td [ngStyle]="{'width': columns[6].width}" style="flex: none; border-width: 0px;" class="text-center">
                    <ng-container *ngIf="canEditHistory(rowData)">
                        <ng-container *ngIf="editingRow !== rowData; else editActionsTemplate">
                            <div (click)="onEditSensorCalibration(rowData)" aria-hidden="true"
                                class="fas fa-pencil-alt" style="color:#64a70b; cursor: pointer; font-size: 14px;">
                            </div>
                        </ng-container>
                        <ng-template #editActionsTemplate>
                            <div class="edit-actions-inline">
                                <i class="fa-regular fa-floppy-disk edit-notes-icon save" (click)="saveCalibrationEdit(rowData)" title="Save"></i>
                                <i class="fa-regular fa-circle-xmark edit-notes-icon cancel" (click)="cancelEdit()" title="Cancel"></i>
                            </div>
                        </ng-template>
                    </ng-container>
                </td>

                <td [ngStyle]="{'width': columns[7].width}" style="flex: none; border-width: 0px;" class="text-center">
                    <div *ngIf="canDeleteHistory(rowData)"
                        (click)="onDeleteCalibrationConfirm(rowData)" aria-hidden="true"
                        class="far fa-trash-alt" style="color:#c8102e; cursor: pointer; font-size: 14px;">
                    </div>
                </td>

                <td [ngStyle]="{'width': columns[8].width}" style="flex: none; border-width: 0px;" class="text-center">
                    <input type="checkbox" [(ngModel)]="rowData.isActive" (ngModelChange)="onActiveChanged(rowData)" class="active-checkbox" />
                </td>

            </tr>
        </ng-template>
    </p-table>

    <p-confirmDialog key="calHistDelete" #calHistDeleteCd>
        <ng-template #footer>
            <button (click)="calHistDeleteCd.onReject()" class="btn btn-basic" type="button">No</button>
            <button (click)="calHistDeleteCd.onAccept()" class="btn btn-success" type="button">Yes</button>
        </ng-template>
    </p-confirmDialog>

</div>